module.exports = __webpack_public_path__ + "static/media/landmannalaugar.9c2df127.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/landmannalaugar.png
 ** module id = 197
 ** module chunks = 0
 **/